module.exports = __webpack_public_path__ + "img/penguin_half.9952c8d5.svg";